import { Grid, Typography } from '@mui/material';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledErrorIcon } from '../../errors/styled-components';

interface StoryBoardItemErrorBoundaryProps {
  children: React.ReactNode;
}

const ErrorFallback = ({ error }: { error: Error }) => {
  const { t } = useTranslation();
  return (
    <Grid
      container
      justifyContent="space-around"
      alignItems="center"
      height="100%"
    >
      <Grid
        item
        container
        alignItems="center"
        spacing={1}
        sx={{ justifyContent: 'center' }}
      >
        <Grid item>
          <StyledErrorIcon sx={{ margin: 0 }} />
        </Grid>
        <Grid item>
          <Typography variant="body2">
            {t(`common:commonValues.error`, { errorMessage: error.message })}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const StoryBoardItemErrorBoundary = (
  props: StoryBoardItemErrorBoundaryProps
) => {
  const { children } = props;

  return (
    <ErrorBoundary
      fallback={(errorData) => (
        <ErrorFallback error={errorData.error as Error} />
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
